import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase/firebaseConfig";
import logotipo_recortado from "../images/logotipo-horizontal_con-nombre_recortado.png";

export default function ResetPassword() {
  const [email, setEmail] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");

  const handleReset = async (e) => {
    e.preventDefault();

    try {
      await sendPasswordResetEmail(auth, email);
      setMensaje("Se ha enviado un enlace para restablecer su contraseña.");
      setError("");
    } catch (err) {
      setError("No se pudo enviar el correo. Verifique el email.");
      setMensaje("");
    }
  };

  return (
    <div className="max-w-sm mx-auto p-4 mt-10 font-sans">

      {/* LOGO */}
      <div className="flex justify-center mb-6">
        <img
          src={logotipo_recortado}
          alt="Logo DISFAGIAPP"
          className="max-w-xs h-auto"
        />
      </div>

      <h2 className="text-xl font-bold text-center mb-4">
        Restablecer contraseña
      </h2>

      <form onSubmit={handleReset} className="space-y-4">
        <label className="block">Correo electrónico:</label>
        <input
          type="email"
          className="w-full border p-2 rounded"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <button
          type="submit"
          className="w-full bg-disfagiapp-blue hover:bg-disfagiapp-blue-hover text-white p-2 rounded font-bold"
        >
          Enviar enlace de recuperación
        </button>
      </form>

      {mensaje && (
        <p className="text-green-600 text-center mt-4">{mensaje}</p>
      )}

      {error && (
        <p className="text-red-600 text-center mt-4">{error}</p>
      )}

      {/* 🔙 BOTÓN VOLVER AL INICIO */}
      <div className="text-center mt-6">
        <button
          onClick={() => window.location.href = "/"}
          className="bg-gray-300 hover:bg-gray-400 text-black font-semibold px-4 py-2 rounded"
        >
          Volver al inicio
        </button>
      </div>

    </div>
  );
}